import type { MessageKind } from "./message-payload";

// Kind predicates — the typed replacement for the legacy `is_system_message`
// branching and content-string matching (`content === "Call ended"` etc.).
// Phase 4a retired the column; every consumer now dispatches on these.
//
// Swift mirror: apps/native/ios/Ano/Core/Models/MessagePredicates.swift
// (strict port — both sides must be updated together when adding kinds).

export function isCallStart(kind: MessageKind): boolean {
  return kind === "call_started_video" || kind === "call_started_audio";
}

export function isCallEnd(kind: MessageKind): boolean {
  return kind === "call_ended";
}

export function isCallEvent(kind: MessageKind): boolean {
  return isCallStart(kind) || isCallEnd(kind);
}

// Replaces the legacy `is_system_message` true-branch behavior: call events
// and catch-all system events render as compact system-message rows (no
// avatar, centered text, different styling).
export function isSystemLike(kind: MessageKind): boolean {
  return isCallEvent(kind) || kind === "system";
}

// Replaces the legacy `!is_system_message` filter in thread-data-model.ts:
// threads can only hang off user-authored content, not call/system events.
export function isThreadable(kind: MessageKind): boolean {
  return !isSystemLike(kind);
}

// User-editable kinds. Media kinds are editable (users can change the caption).
// Call/system events are not. Most card kinds are producer-owned and not
// editable, except `terminal_output` — users can fix the command/output text
// of terminal cards they sent (sender-scoped via the editMessage mutator's
// ctx.sub check).
export function isEditable(kind: MessageKind): boolean {
  return (
    kind === "text" ||
    kind === "image" ||
    kind === "video" ||
    kind === "audio" ||
    kind === "gif" ||
    kind === "file" ||
    kind === "media_group" ||
    kind === "link_only" ||
    kind === "terminal_output"
  );
}
